import { resetAuditGroupActions } from '../config/actions';

const defaultState = {
  isLoading: null,
  data: null,
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case resetAuditGroupActions.RESET_GROUP_AUDIT_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: state.data || null,
        error: null
      };
    case resetAuditGroupActions.RESET_GROUP_AUDIT_ERROR:
      return {
        ...state,
        isLoading: false,
        data: state.data || null,
        error: action.error,
        history: state.history || []
      };
    case resetAuditGroupActions.RESET_GROUP_AUDIT:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        error: null
      };
    case resetAuditGroupActions.RESET_GROUP_AUDIT_RESET:
      return {
        ...state,
        isLoading: false,
        data: null,
        error: null
      };
    default:
      return state;
  }
};
